import {
  TEntityOverride,
} from 'src/types'

const override: TEntityOverride = {
  titleField: 'id',
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
    },
  },
}

export default override
